angular.module('CarsSaraBo').controller('RateController', [
    '$scope', '$routeParams', '$filter', 'ContractService', 'RangeDefinitionService', 'DateService',
    'FleetService', 'AlertEmailService', '$window', 'PointOfSaleService', 'RatePriceService',
    'GAService', '$cookies', 'ItemSelectorService', 'SessionService', 'NotificationService',
    'LoadingWheelService', 'ModalService', '$q',
    function ($scope, $routeParams, $filter, contractService, rangeDefinitionService, dateService,
              fleetService, alertEmailService, $window, pointOfSaleService, ratePriceService,
              gaService, $cookies, itemSelectorService, sessionService, notificationService,
              loadingWheelService, modalService, $q) {

        function initialize() {
            loadingWheelService.show();
            $scope.validations = {
                hasRequiredAlerts: ["RESERVE_MODIFICATION", "CANCELLATION", "RESERVE"]
            };
            loadData();
            $scope.rates = [];
            $scope.show = false;
            $scope.period = {from: new Date(), to: null};
            $scope.errorMessages = {};
            $scope.carPrices = {};
            $scope.ratePrices = null;
            $scope.companyOid = $routeParams.oid;
            $scope.editableAvailability = sessionService.loggedUserAllowed('PERM_PRICE_EDIT');
            $scope.selectAll = false;
            $scope.posSelected = {};
            notifyGA("page_views", ["Page view"]);
            $scope.currencyCode = sessionService.session.currencyCode;
            $scope.alertsByPos = {};
            $scope.noAlertsInPos = [];
            $scope.emptyAlerts = [];
            $scope.updateDate = calculateMaxDate();
            loadAlertsByCompany();

        }

        const MARKUP_NOTIFICATION_CONFIRMED = "Markup_nofitication_confirmed";

        function calculateMaxDate() {
            var date = new Date();
            var dateWithYears = new Date(date.setFullYear(new Date().getFullYear() + 2));
            return formatDate(dateWithYears);
        }

        function formatDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [d.getFullYear(), pad(d.getMonth()+1), pad(d.getDate())].join('-');
        }

        function loadAlertsByCompany(){
            alertEmailService.query({companyOid: $routeParams.oid}, function (response) {
                $scope.validations.totalEmails = [];
                _.each(response, function (elem) {
                    $scope.validations.totalEmails.push(elem.email);
                    _.each(elem.pointOfSaleOids, function (pos) {
                        if(!($scope.alertsByPos.hasOwnProperty(pos))){
                            $scope.alertsByPos[pos] = [];
                        }
                        for (var i in elem.types){
                            if ($scope.alertsByPos[pos].indexOf(elem.types[i]) == -1){
                                $scope.alertsByPos[pos].push(elem.types[i]);
                            }
                        }
                    });
                });
            });
        }

        function verifyMarkupMessage(contract) {
            if (contract == undefined) {
                loadingWheelService.hide();
            } else {
                $scope.validations.markupNotification = false;
                var isMarkupCompany = (contract.commissionType === 'MARKUP') ? true : false;
                $scope.validations.isMarkupCompany = isMarkupCompany;
                var makupCookie = $cookies.get(MARKUP_NOTIFICATION_CONFIRMED);
                if (isMarkupCompany && (!makupCookie)) {
                    $scope.validations.markupNotification = true;
                }
            }
        }

        $scope.cancel = function () {
            modalService.show("CANCEL_ALERT_TITLE", "CANCEL_ALERT_DESCRIPTION", function () {
                initialize();
            });
        };

        $scope.updateValidation = function (field) {
            if ($scope.errorField != undefined && $scope.errorField[field]) {
                $scope.errorField[field] = null;
            }
            if ($scope.formComponentError != undefined && $scope.formComponentError[field]) {
                $scope.formComponentError[field] = null;
            }
        };

        $scope.save = function () {
            var deferred = $q.defer();
            notifyGA("guardar_precio", [formatDate2($scope.period.from, "yyyyMMdd"), formatDate2($scope.period.to, "yyyyMMdd")]);
            $scope.errorField = {};
            $scope.formComponentError = {};
            if (isValid() && $scope.rateForm.$valid) {
                ratePriceService.save($scope.carPrices, $routeParams.oid, $scope.pointsOfSaleSelector.items, $scope.period)
                    .then(function (response) {
                        notifyGA("submit_form", ["Exitoso"]);
                        deferred.resolve();
                        initialize();
                        notificationService.notifyInfoByCode('rate.confirmationMessage.SUCCESS_SAVE');
                    }, function (error) {
                        notifyGA("submit_form", "ERROR");
                        deferred.reject();
                    });
            } else {
                notifyGA("submit_form", ["Error"]);
                deferred.reject();
                for (var i in $scope.rateForm.$error.required) {
                    var fieldName = $scope.rateForm.$error.required[i].$name;
                    $scope.errorField[fieldName] = "input-error";
                    notifyGA("errores_validacion", [fieldName + ":required"]);
                }
                notificationService.notifyFormErrors($scope.rateForm.$error);
            }
            return deferred.promise;
        };

        $scope.searchPrices = function (carOid) {
            var pointsOfSaleOid = $scope.pointsOfSaleSelector.getSelectedItemsOid();
            if (validateSearchFields(pointsOfSaleOid)) {
                notifyGA("verificar_conflicto", [formatDate2($scope.period.to, "yyyyMMdd")]);
                ratePriceService.searchPrices($scope.period, $routeParams.oid, pointsOfSaleOid, carOid).success(function (response) {
                    $window.scrollTo(0, 0);
                    $scope.ratePrices = response.sort(function (a, b) {
                        if (a.rangeDefinitionDays < b.rangeDefinitionDays ||
                            (a.rangeDefinitionDays == b.rangeDefinitionDays && a.period.from < b.period.from)) {
                            return -1;
                        } else if (a.rangeDefinitionDays > b.rangeDefinitionDays ||
                            (a.rangeDefinitionDays == b.rangeDefinitionDays && a.period.from > b.period.from)) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                });
            } else {
                return false;
            }
        };

        $scope.verifyClear = function (carOid, rangeOid) {
            var value = $scope.carPrices[carOid][rangeOid];
            if (value == null || value == undefined || value == "") {
                delete $scope.carPrices[carOid][rangeOid];
            }
        };

        $scope.formatDate2 = formatDate2;

        function formatDate2(date, format) {
            try {
                if (format == null || format == undefined) {
                    format = "dd/MM/yyyy";
                }
                return $filter("date")(date, format);
            } catch (e) {
                return "unknown-date";
            }
        }

        function loadData() {
            function getFleet() {
                var fieldsCar = "oid,name,carModel";
                fleetService.get({companyOid: $routeParams.oid, fields: fieldsCar}, function (response) {
                    $scope.fleet = response;
                    $scope.validations.fleet = $scope.fleet.length > 0 ? true : false;
                });
            }

            function getRangeDefinitions() {
                rangeDefinitionService.get({companyOid: $routeParams.oid}, function (response) {
                    $scope.rangeDefinitions = response.sort(function compare(a, b) {
                        if (a.startRange < b.startRange)
                            return -1;
                        if (a.startRange > b.startRange)
                            return 1;
                        return 0;
                    });
                });
            }

            function getPointsOfSaleAndContract() {
                var fieldsContract = "name, oid, period, valid, rateBoundedByCategory, rateAmountBounds, defaultRateAmountBound, pointsOfSale, commissionType";
                pointOfSaleService.resource.query({companyOid: $routeParams.oid}, function (pointsOfSale) {
                    contractService.getAll({
                        companyOid: $routeParams.oid,
                        fields: fieldsContract
                    }, function (contracts) {
                        var contract = contracts[0];
                        $scope.contract = contract;
                        verifyMarkupMessage(contract);
                        $scope.validations.contract = contract != null;

                        _.each(contract.pointsOfSale, function (pointOfSaleOid) {
                            var name = ratePriceService.findNameOnPosList(pointsOfSale, pointOfSaleOid);
                            $scope.posSelected[pointOfSaleOid] = {name: name};
                        });

                        $scope.validations.pos = Object.keys($scope.posSelected).length > 0 ? true : false;
                        loadingWheelService.hide();

                        if (!$scope.contract) {
                            $scope.pointsOfSale = [];
                        } else {
                            $scope.pointsOfSale = _.filter(pointsOfSale, function (pos) {
                                return _.includes($scope.contract.pointsOfSale, pos.oid);
                            });
                        }
                        var pointsOfSaleOid = _.map($scope.contract.pointsOfSale, 'oid');
                        $scope.pointsOfSaleSelector = pointOfSaleService.getPointsOfSaleSelectorConfig($scope.pointsOfSale, pointsOfSaleOid);

                    });
                });
            }

            function getAlerts() {
                alertEmailService.query({companyOid: $routeParams.oid}, function (reponse) {
                    $scope.validations.hasRequiredAlerts = ["RESERVE_MODIFICATION", "CANCELLATION", "RESERVE"];
                    _.each(reponse, function (elem) {
                        _.each(elem.types, function (type) {
                            var index = $scope.validations.hasRequiredAlerts.indexOf(type);
                            if (index > -1) {
                                $scope.validations.hasRequiredAlerts.splice(index, 1);
                            }
                        });
                    });
                });
            }

            getRangeDefinitions();
            getPointsOfSaleAndContract();
            getFleet();
            getAlerts();
        }

        /*****VALIDATIONS******/
        function validateSearchFields(pointsOfSaleOid) {
            $scope.errorField = {};
            var isValid = true;
            if ((!$scope.period.to) || (!$scope.period.from)) {
                $scope.errorField['maxDate'] = "input-error";
                isValid = false;
            }

            if (!(pointsOfSaleOid.length > 0)) {
                $scope.errorField['ratePos'] = "input-error";
                isValid = false;
            }

            if (!isValid) {
                notificationService.notifyErrorByCodeWithParams("common.form.validation.UNCOMPLETE_REQUIRED_FIELD");
            }

            return isValid;
        }

        function isValid() {
            var isValid = true;
            $scope.errorList = [];
            var errorMessageList = [];
            var contract = $scope.contract;

            if (!_.some($scope.pointsOfSaleSelector.getSelectedItemsOid())) {
                isValid = false;
                $scope.errorField['ratePos'] = "input-error";
                $scope.errorList.push({code: "rate.posSelection.ERROR_MISSING"});
                notifyGA("errores_validacion", ["pointOfSale:required"]);
            }

            if(!checkValidAlerts()){
                isValid = false;
                $scope.errorField['pointsOfSale'] = "input-error";
                if($scope.noAlertsInPos.length > 0){
                    errorMessageList.push({
                        code: "alert.NO_ALERTS_REGISTERED_TITLE",
                        params: ["alertEmail.RESERVE", "alertEmail.CANCELLATION", "alertEmail.MODIFICATIONS", "alert.NO_VALID_MAIL_ACTION"]
                    });
                }
                if($scope.emptyAlerts.length > 0 && $scope.emptyAlerts.length <=2){
                    errorMessageList.push({
                        code: "alert.NO_VALID_MAIL_POS",
                        params: [$scope.emptyAlerts.join(', '), "alert.NO_VALID_MAIL_ACTION"]
                    });
                }else if( $scope.emptyAlerts.length > 2){
                    errorMessageList.push({
                        code: "alert.NO_VALID_MAIL_ALL",
                        params: ["alert.NO_VALID_MAIL_ACTION"]
                    });
                }

                for (var i in errorMessageList) {
                    notificationService.notifyErrorByCodeWithMessageAndErrorList(errorMessageList[i].code, errorMessageList[i].params);
                }
            }

            if (!validatePeriod($scope.period, contract.period)) {
                isValid = false;
            }

            if (hasWrongPrices($scope.carPrices, contract, isValid)) {
                isValid = false;
                notifyGA("errores_validacion", ["carPrices:invalid"]);
            }

            if ($scope.errorList.length > 0) {
                for (var i in $scope.errorList) {
                    notificationService.notifyErrorByCodeWithParams($scope.errorList[i].code, $scope.errorList[i].params);
                }
            }

            return isValid;
        }

        function validatePeriod(selectedPeriod, contractPeriod) {
            var isValid = true;

            var today = moment().startOf('day');
            var contractFrom = moment(contractPeriod.from).startOf('day');

            var validFrom = contractFrom > today ? contractFrom : today;
            var validTo = moment().add(2, 'y').startOf('day');

            if (selectedPeriod && selectedPeriod.from && selectedPeriod.to && selectedPeriod.from.setHours(0, 0, 0, 0) > selectedPeriod.to.setHours(0, 0, 0, 0)) {
                isValid = false;
                $scope.errorField['maxDate'] = "input-error";
                $scope.errorList.push({
                    code: "common.INVALID_PERIOD",
                    params: {
                        contractFrom: validFrom.format("D/MM/YYYY"),
                        contractTo: validTo.format("D/MM/YYYY")
                    }
                });
                notifyGA("errores_validacion", ["period:invalid"]);
            }

            if (selectedPeriod.from < validFrom || selectedPeriod.to > validTo) {
                isValid = false;
                $scope.errorField['rangeDate'] = "input-error";
                $scope.errorList.push({
                    code: "common.INVALID_PERIOD",
                    params: {
                        contractFrom: validFrom.format("D/MM/YYYY"),
                        contractTo: validTo.format("D/MM/YYYY")}
                });
                notifyGA("errores_validacion", ["period:ouf_of_contract"]);
            }
            return isValid;
        }

        function toDate(dateString) {
            return moment(dateString).toDate();
        }

        function getPosNames(selectedPos){
            $scope.emptyAlerts = [];
            _.each(selectedPos, function (posOid) {
                _.each($scope.pointsOfSale, function (pos){
                    if(posOid == pos.oid){
                        $scope.emptyAlerts.push(pos.name);
                    }
                })
            });
        }

        function checkValidAlerts(){
            var isValid = true;
            var selectedPos = $scope.pointsOfSaleSelector.getSelectedItemsOid(); //sucursales seleccionadas
            var emptyAlerts = [];
            $scope.noAlertsInPos = [];

            for (var i in selectedPos){
                if($scope.alertsByPos.hasOwnProperty(selectedPos[i])){
                    _.forEach($scope.alertsByPos, function(alerts, pos) {
                        if(selectedPos[i] == pos){
                            if(alerts.indexOf('RESERVE') == -1 || alerts.indexOf('CANCELLATION') == -1
                                || alerts.indexOf('RESERVE_MODIFICATION') == -1){
                                $scope.noAlertsInPos.push(pos);
                                isValid = false;
                                return false;
                            }
                        }
                    });
                }else{
                    emptyAlerts.push(selectedPos[i]);
                    isValid = false;
                }
            }
            getPosNames(emptyAlerts);

            return isValid;
        }

        function selectCar(carOid) {
            var selectedCar = null;
            _.each($scope.fleet, function (car) {
                if (car.oid == carOid) {
                    selectedCar = car;
                    return false; // break _.each(...);
                }
            });
            return selectedCar;
        }

        function hasWrongPrices(prices, contract, isValid) {
            var hasOne = false;
            var hasWrongPrices = false;
            $scope.carPricesErrors = {};
            for (var carOid in prices) {
                var car = selectCar(carOid);
                var minBound;
                var maxBound;
                if (contract.rateBoundedByCategory) {
                    var categoryCode = car.carModel.categoryCode;
                    var range = contract.rateAmountBounds[categoryCode];
                    minBound = range.min;
                    maxBound = range.max;
                } else {
                    minBound = contract.defaultRateAmountBound.min;
                    maxBound = contract.defaultRateAmountBound.max;
                }
                for (var rangeDefinitionOid in prices[carOid]) {
                    var rateAmount = prices[carOid][rangeDefinitionOid];
                    if (rateAmount != "" && rateAmount != null) {
                        hasOne = true;
                        var fieldName = 'carPrice_' + carOid + '_' + rangeDefinitionOid;
                        var errorMessageBox = "error_" + fieldName;
                        if (!$scope.validAmountField(rateAmount)) {
                            $scope.errorField[fieldName] = "form-component-error";
                            $scope.formComponentError[fieldName] = {
                                messageKey: 'warning.invalidNumberFormat',
                            };
                            if (!hasWrongPrices && isValid) {
                                $window.document.getElementsByName(fieldName)[0].scrollIntoView(false);
                            }
                            hasWrongPrices = true;
                        } else {
                            validAmount = $scope.parseValidAmount(rateAmount);

                            if (validAmount < minBound) {
                                $scope.errorField[fieldName] = "form-component-error";
                                $scope.formComponentError[fieldName] = {
                                    messageKey: 'rate.RATE_VALUE_ERROR_MIN_BOUND',
                                    messageParams: {
                                        valueMin: minBound,
                                        currencyCode: $scope.getSession().currencyCode
                                    }
                                };
                                if (!hasWrongPrices && isValid) {
                                    $window.document.getElementsByName(fieldName)[0].scrollIntoView(false);
                                }
                                hasWrongPrices = true;
                            }
                            if (validAmount > maxBound) {
                                $scope.errorField[fieldName] = "form-component-error";
                                $scope.formComponentError[fieldName] = {
                                    messageKey: 'rate.RATE_VALUE_ERROR_MAX_BOUND',
                                    messageParams: {
                                        valueMax: maxBound,
                                        currencyCode: $scope.getSession().currencyCode
                                    }
                                };
                                if (!hasWrongPrices && isValid) {
                                    $window.document.getElementsByName(fieldName)[0].scrollIntoView(false);
                                }
                                hasWrongPrices = true;
                            }
                        }
                    }
                }
            }
            if (!hasOne) {
                $scope.errorField['carPrices'] = "input-error";
                $scope.errorList.push({code: "ERROR.rates.emptyRates"});
                hasWrongPrices = true;
                if (isValid) {
                    $window.document.getElementById("ratesDiv").scrollIntoView();
                }
            }
            return hasWrongPrices;
        }

        function notifyGA(eventName, paramsList) {
            gaService.notify("Autos_precios", eventName, paramsList);
        }

        initialize();
    }]);



//////////////////
// WEBPACK FOOTER
// ./public/app/rate/rate_controller.js
// module id = 824
// module chunks = 3